// import RootComponent from "../components/RootComponent";

import RootComponent from "../components/RootComponent";

function RootPage() {
    return (
        <RootComponent />
    );
}


export default RootPage;